// Maps admin-panel sections to the backend permission module keys
// (see Backendsrv/utils/permissions.js). A section is visible when the user
// has `<module>.view` (or the explicit `viewPermission`).
export const SECTION_PERMISSIONS = {
  users: { module: "users" },
  roles: { module: "roles", viewPermission: "roles.manage" },
  branding: { module: "branding" },
  appgroups: { module: "appGroups" },
  pandits: { module: "pandits" },
  departments: { module: "departments" },
  events: { module: "events" },
  quizzes: { module: "quizzes" },
  prayers: { module: "prayers" },
  dailyprayers: { module: "dailyPrayers" },
  specialdays: { module: "specialDays" },
  mandirs: { module: "mandirs" },
  hindilearning: { module: "hindiLearning" },
  kinderhuis: { module: "kinderhuis" },
  ebibliotheek: { module: "ebibliotheek" },
  dharmalearning: { module: "dharmaArticles" },
  schools: { module: "scholen" },
  hoofdbestuur: { module: "hoofdbestuur" },
  blogs: { module: "blogs" },
  kyun: { module: "kyun" },
  dailyquotes: { module: "dailyQuotes" },
  bhojan: { module: "bhojan" },
  yoga: { module: "yoga" },
  mail: { module: "mail", viewPermission: "mail.send" },
};

export const sectionViewPermission = (sectionKey) => {
  const section = SECTION_PERMISSIONS[sectionKey];
  if (!section) return null;
  return section.viewPermission || `${section.module}.view`;
};

// "/admin/dailyprayers" -> { module: "dailyPrayers", ... }
export const sectionFromPath = (pathname = "") => {
  const match = String(pathname).match(/^\/admin\/([^/?#]+)/);
  return match ? SECTION_PERMISSIONS[match[1]] || null : null;
};

export const hasPermission = (user, permission) => {
  if (!permission) return true;
  if (!user) return false;
  if (user.role === "admin") return true;
  return Array.isArray(user.permissions) && user.permissions.includes(permission);
};
